module.exports = __webpack_public_path__ + "img/pause_event.fb59f499.svg";